/* Imports */
import React from 'react';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import _adviserPortalHome from '../Components/_adviserPortalHome';
import { withTranslation } from 'react-i18next';
import '../css/AdviserPortalCharts.css';
/* Chart code */
// Themes begin
am4core.useTheme(am4themes_animated);
// Themes end

function MembersGraph(props){
  const {t} = props;
// Create chart instance
let chart = am4core.create("membersChart", am4charts.XYChart);
chart.logo.setVisibility(false)
// let title = chart.titles.create();
// title.text = "Total Members";
// title.fontSize = 15;
// title.fontFamily = "Roboto sans-serif";

const total_fum = _adviserPortalHome._totalFumInDetail(_adviserPortalHome._adviserDahsboardBodyInDetail(props))

// Add data
chart.data = [];
// chart.data = [{
//   "product": "SLKS",
//   "fum": total_fum.kiwiSaver/1000000,
//   // "color": "#81B037"

// }, {
//     "product": "SLI",
//     "fum": total_fum.invest/1000000,
//     // "color": "#e26a09"


// }, {
//     "product": "SLUK",
//     "fum": total_fum.ukPension/1000000,
//     // "color": "#a90017"
// }];

total_fum.productFum.map(fum => {
  const data = {
    product: fum.code,
    fum: fum.fum
  }
  chart.data.push(data)
})

// Create axes
let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
categoryAxis.dataFields.category = "product";
categoryAxis.dataFields.data = "fum";
categoryAxis.renderer.grid.template.location = 0;
categoryAxis.renderer.grid.template.disabled = true;
// categoryAxis.renderer.grid.template.width= 10;
categoryAxis.renderer.labels.template.fill = am4core.color("#3d4d5c");
categoryAxis.renderer.minGridDistance = 0;
// categoryAxis.renderer.labels.template.adapter.add("dy", function(dy, target) {
//   if (target.dataItem && target.dataItem.index & 2 == 2) {
//     return dy + 25;
//   }
//   return dy;
// });

let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
valueAxis.renderer.labels.template.fill = am4core.color("#3d4d5c")
valueAxis.renderer.minGridDistance = 50;
// valueAxis.renderer.grid.template.disabled = true;


chart.colors.list = [
 am4core.color("#51820F")
];

// Create series
let series = chart.series.push(new am4charts.ColumnSeries());
series.dataFields.valueY = "fum";
series.dataFields.categoryX = "product";
series.name = "FUM";
series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
series.columns.template.fillOpacity = .8;
series.columns.template.propertyFields.fill = "color";
series.columns.template.width = 50;
let columnTemplate = series.columns.template;
columnTemplate.strokeWidth = 2;
columnTemplate.strokeOpacity = 1;


return (
  <div style={{textAlign: "center"}}> 
    <div className="membersChartTitle">{t('Graphs:membersGraphTitle')}</div>
    <div id="membersChart"></div>
    </div>

  
)
}

export default withTranslation()(MembersGraph);